"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find");
var _index = _interopRequireDefault(require("@/views/caseConditions/index.vue"));
var _inquiry = require("@/api/inquiry.js");
var _dictionary = require("@/config/dictionary");
var _index2 = require("@/utils/index.js");
var _arbitrator = require("@/api/arbitrator");
var _updateAdmin = _interopRequireDefault(require("../../commission/user/updateAdmin.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "division",
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      loading: true,
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      tableData: [],
      secretaryList: [],
      total: 0,
      //总页数
      conditionData: "",
      //来自子组件的数据
      caseState: _dictionary.dictionary.caseState,
      multipleSelection: [],
      multipleSelectionId: [],
      wayList: [{
        name: "书面审理",
        id: "1"
      }, {
        name: "线下开庭",
        id: "2"
      }, {
        name: "视频开庭",
        id: "3"
      }],
      divisionLotVisible: false,
      //案件组庭批量弹窗显示
      divisionLotForm: {
        //案件组庭批量数据
        chiefArbitratorId: "",
        chiefArbitratorName: "",
        trialWay: ""
      },
      divisionRules: {
        secretaryId: [{
          required: true,
          trigger: "change",
          message: "请选择处理人"
        }],
        trialWay: [{
          required: true,
          message: "请选择审理方式",
          trigger: "change"
        }],
        opinion: [{
          required: true,
          trigger: "blur",
          message: "请填写意见"
        }]
      },
      divisionVisible: false,
      //案件组庭弹窗显示
      divisionForm: {
        //案件组庭数据
        chiefArbitratorId: "",
        chiefArbitratorName: "",
        secondArbitratorId: "",
        secondArbitratorName: "",
        thirdArbitratorId: "",
        thirdArbitratorName: "",
        trialWay: ""
      },
      caseId: "",
      caseNum: "",
      node: "",
      arbitratorList: [],
      partyChoiceArb: {
        secretaryId: "",
        opinion: "",
        secretaryName: "",
        href: "",
        trialWay: ""
      },
      batchArbVisible: false,
      batchSign: {
        secretaryId: "",
        secretaryName: "",
        opinion: "",
        trialWay: ""
      },
      allLoading: false,
      //全屏loading
      sendCaseVisible: false,
      //案件送达
      gotoServicing: false //选定仲裁员弹窗 按钮loading
    };
  },
  created: function created() {
    this.init();
  },
  components: {
    Caseconditons: _index.default
  },
  methods: {
    handleProcess: function handleProcess() {
      var _this = this;
      this.$refs.batchSign.validate(function (valid) {
        if (valid) {
          var params = _this.batchSign;
          _this.secretaryList.find(function (item) {
            if (item.id == _this.batchSign.secretaryId) {
              _this.batchSign.secretaryName = item.name;
            }
          });
          (0, _inquiry.batchTask)({
            caseIds: _this.onGetBatchIds(),
            caseState: 23,
            content: JSON.stringify(params)
          }).then(function (res) {
            if (res.code == 1) {
              _this.sumbiting = false;
              _this.$message({
                message: '批量操作成功',
                type: 'success'
              });
              _this.init();
              _this.batchArbVisible = false;
            } else {
              _this.$message.error(res.msg);
              _this.batchArbVisible = false;
            }
          });
        } else {
          return;
        }
      });
    },
    onGetBatchIds: function onGetBatchIds() {
      var ids = [];
      for (var i = 0; i < this.multipleSelection.length; i++) {
        var item = this.multipleSelection[i];
        ids.push(item.caseId);
      }
      return ids;
    },
    init: function init() {
      var _this2 = this;
      (0, _inquiry.getList)({
        state: "23",
        limit: this.pageLimit,
        page: this.currentPage
      }).then(function (res) {
        if (res.code == 1) {
          _this2.tableData = res.rows;
          _this2.total = res.total;
          _this2.loading = false;
          _this2.gotoServicing = false;
        }
      });
    },
    handleDetail: function handleDetail(val) {
      this.$router.push({
        name: "inquiryDetail",
        params: {
          caseId: val
        }
      });
    },
    //点击筛选，发送请求列表
    checkList: function checkList(data) {
      var _this3 = this;
      // 需要发送给后端的数据
      this.currentPage = 1;
      var postData = {
        caseId: data.caseId,
        caseNo: data.caseNo,
        partyName: data.partyName,
        defenceState: data.replyvalue,
        beginCtime: data.rowSecondDate[0],
        endCtime: data.rowSecondDate[1],
        caseType: data.caseTypevalue,
        beginRegisterTime: data.rowThirdDate[0],
        endRegisterTime: data.rowThirdDate[1],
        source: data.caseOriginvalue,
        state: "23",
        limit: this.pageLimit,
        page: 1
      };
      this.conditionData = postData;
      (0, _inquiry.getList)(this.conditionData).then(function (res) {
        if (res.code == 1) {
          _this3.tableData = res.rows;
          _this3.total = res.total;
        }
      });
    },
    //点击 清空所有筛选条件
    cleanConditionData: function cleanConditionData() {
      this.conditionData = "";
      this.currentPage = 1;
      this.init();
    },
    //表格禁止勾选事件
    selectable: function selectable(row, index) {
      if (row.arbitratorName) {
        return true;
      } else {
        return false;
      }
    },
    // 表格勾选事件
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getSecretaryListInfo: function getSecretaryListInfo(data) {
      var _this4 = this;
      (0, _inquiry.getSecretaryList)({
        id: data
      }).then(function (res) {
        if (res.code == 1) {
          // this.secretaryList = res.data[0].allReviews;
          _this4.partyChoiceArb.opinion = res.data[0].content;
          // this.partyChoiceArb.secretaryName = this.secretaryList[0].name;
          // this.partyChoiceArb.secretaryId = this.secretaryList[0].id;
        } else {
          _this4.$message({
            message: res.msg,
            type: "error"
          });
        }
      }).catch(function (error) {});
    },
    signArbitrationNoticeFiles: function signArbitrationNoticeFiles(data) {
      var _this5 = this;
      (0, _inquiry.signArbitrationNoticeFiles)({
        caseId: data
      }).then(function (res) {
        if (res.code == 1) {
          _this5.partyChoiceArb.href = res.data;
        } else {
          _this5.$message({
            message: res.msg,
            type: "error"
          });
        }
      }).catch(function (error) {});
    },
    //已选择仲裁员
    getChoiceArbitrator: function getChoiceArbitrator(data) {
      var _this6 = this;
      (0, _inquiry.getChoiceArbitrator)(data).then(function (res) {
        if (res.code == 1) {
          _this6.partyChoiceArb.appArbitratorName = res.data.appArbitratorName;
          _this6.partyChoiceArb.resArbitratorName = res.data.resArbitratorName;
          _this6.partyChoiceArb.content = res.data.content;
          _this6.partyChoiceArb.replyName = res.data.replyName;
        }
      });
      this.getSecretaryListInfo(data);
    },
    handleReview: function handleReview(data) {
      var _this7 = this;
      this.caseId = data.caseId;
      this.allLoading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.sendCaseVisible = true;
      this.$nextTick(function () {
        _this7.$refs.sendCase.init(_this7.caseId, 23);
      });
    },
    //查看
    handleCheck: function () {
      var _handleCheck = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(data) {
        var strData, vdata, admin, composeType, secondArbitratorId, secondArbitratorName, thirdArbitratorId, thirdArbitratorName, chiefArbitratorId, chiefArbitratorName;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.caseId = data.caseId;
              this.node = data.node;
              this.divisionVisible = true;
              this.partyChoiceArb.trialWay = this.wayList[0].id;
              this.getSecretaryListInfo(this.caseId);
              this.signArbitrationNoticeFiles(this.caseId);
              this.secretaryList = [{
                id: data.handingSecretaryId,
                name: data.handingSecretaryName
              }];
              this.partyChoiceArb.secretaryId = data.handingSecretaryId;
              this.partyChoiceArb.secretaryName = data.handingSecretaryName;
              _context.next = 11;
              return (0, _inquiry.onfindArbitratorByCaseId)(this.caseId);
            case 11:
              strData = _context.sent;
              if (strData) {
                vdata = strData.data || null;
                if (vdata) {
                  admin = JSON.parse(window.localStorage.admin);
                  composeType = vdata.composeType, secondArbitratorId = vdata.secondArbitratorId, secondArbitratorName = vdata.secondArbitratorName, thirdArbitratorId = vdata.thirdArbitratorId, thirdArbitratorName = vdata.thirdArbitratorName, chiefArbitratorId = vdata.chiefArbitratorId, chiefArbitratorName = vdata.chiefArbitratorName;
                  if (composeType == 2) {
                    if (admin.id == chiefArbitratorId && secondArbitratorId) {
                      this.partyChoiceArb.secretaryId = secondArbitratorId;
                      this.partyChoiceArb.secretaryName = secondArbitratorName;
                      this.secretaryList = [{
                        id: secondArbitratorId,
                        name: secondArbitratorName
                      }];
                      // this.updateRevie(secondArbitratorId, secondArbitratorName);
                    } else if (admin.id == secondArbitratorId && thirdArbitratorId) {
                      // this.updateRevie(thirdArbitratorId, thirdArbitratorName);
                      this.partyChoiceArb.secretaryId = thirdArbitratorId;
                      this.partyChoiceArb.secretaryName = thirdArbitratorName;
                      this.secretaryList = [{
                        id: thirdArbitratorId,
                        name: thirdArbitratorName
                      }];
                    }
                  }
                }
              }
              // console.log(data);
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleCheck(_x) {
        return _handleCheck.apply(this, arguments);
      }
      return handleCheck;
    }(),
    ///回退成功待对接接口
    handleBack: function handleBack(data) {
      var _this8 = this;
      // console.log(data);
      this.$prompt("此操作将回退该案件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        distinguishCancelAndClose: true,
        inputPlaceholder: "请输入原因!",
        inputErrorMessage: "请输入原因",
        inputValidator: function inputValidator(value) {
          if (!value) return false;
          return true;
        }
      }).then(function (obj) {
        (0, _arbitrator.batchExamineAuditExt)({
          caseId: data.caseId,
          reason: obj.value
        }).then(function (jd) {
          _this8.$message({
            type: "success",
            message: "回退成功!"
          });
          _this8.init();
        });
      }).catch(function () {
        // this.$message({
        //   type: "info",
        //   message: "回退取消"
        // });
      });
    },
    updateShow: function updateShow() {
      this.divisionVisible = false;
      this.sendCaseVisible = true;
      this.gotoServicing = false;
      if (!this.fullscreenLoading) {
        this.fullscreenLoading = false;
      }
    },
    updateErrorShow: function updateErrorShow() {
      this.sendCaseVisible = false;
      this.gotoServicing = false;
    },
    // 审核通过后刷新数据
    refreshPage: function refreshPage() {
      this.sendCaseVisible = false;
      this.init();
    },
    //进行组庭
    caseCourtAdopt: function () {
      var _caseCourtAdopt = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(divisionForm) {
        var admin, strData, data, composeType, secondArbitratorId, secondArbitratorName, thirdArbitratorId, thirdArbitratorName, chiefArbitratorId, chiefArbitratorName;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              admin = JSON.parse(window.localStorage.admin);
              _context2.next = 3;
              return (0, _inquiry.onfindArbitratorByCaseId)(this.caseId);
            case 3:
              strData = _context2.sent;
              if (strData) {
                data = strData.data || null;
                if (data) {
                  composeType = data.composeType, secondArbitratorId = data.secondArbitratorId, secondArbitratorName = data.secondArbitratorName, thirdArbitratorId = data.thirdArbitratorId, thirdArbitratorName = data.thirdArbitratorName, chiefArbitratorId = data.chiefArbitratorId, chiefArbitratorName = data.chiefArbitratorName; //1 独任庭 2 三人庭
                  if (composeType == 2) {
                    if (admin.id == chiefArbitratorId && secondArbitratorId) {
                      this.updateRevie(secondArbitratorId, secondArbitratorName);
                    } else if (admin.id == secondArbitratorId && thirdArbitratorId) {
                      this.updateRevie(thirdArbitratorId, thirdArbitratorName);
                    } else {
                      this.submitGotoServe(divisionForm);
                    }
                  } else {
                    this.submitGotoServe(divisionForm);
                  }
                } else {
                  this.submitGotoServe(divisionForm);
                }
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function caseCourtAdopt(_x2) {
        return _caseCourtAdopt.apply(this, arguments);
      }
      return caseCourtAdopt;
    }(),
    submitGotoServe: function submitGotoServe(divisionForm) {
      var _this9 = this;
      this.$refs[divisionForm].validate(function (valid) {
        if (valid) {
          _this9.gotoServicing = true;
          _this9.secretaryList.forEach(function (item) {
            if (item.id == _this9.partyChoiceArb.secretaryId) {
              _this9.partyChoiceArb.secretaryName = item.name;
            }
          });
          (0, _inquiry.procedureByAdopt)({
            caseId: _this9.caseId,
            node: _this9.node,
            reviewId: _this9.partyChoiceArb.secretaryId,
            reviewName: _this9.partyChoiceArb.secretaryName,
            content: _this9.partyChoiceArb.opinion
          }).then(function (res) {
            if (res.code == 1) {
              _this9.$message({
                message: "进行组庭成功",
                type: "success"
              });
              _this9.divisionVisible = false;
              _this9.gotoServicing = false;
              _this9.init();
            }
          });
        } else {
          _this9.gotoServicing = false;
        }
      });
    },
    updateRevie: function () {
      var _updateRevie = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(reviewId, reviewName) {
        var _this10 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              (0, _inquiry.onCaseBatchHandleUpdateReview)({
                caseId: this.caseId,
                reviewId: reviewId,
                reviewName: reviewName
              }).then(function (res) {
                if (res.code == 1) {
                  _this10.$message({
                    message: "操作成功",
                    type: "success"
                  });
                  _this10.divisionVisible = false;
                  _this10.init();
                } else {
                  _this10.$message({
                    message: "操作失败",
                    type: "waring"
                  });
                }
              }).catch(function (error) {
                _this10.$message({
                  message: "操作失败",
                  type: "waring"
                });
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateRevie(_x3, _x4) {
        return _updateRevie.apply(this, arguments);
      }
      return updateRevie;
    }(),
    //批量审核
    batchReview: function batchReview() {
      this.caseNum = this.multipleSelectionId.length;
      this.caseId = this.multipleSelection[0].caseId;
      this.node = this.multipleSelection[0].node;
      this.secretaryList = [{
        id: this.multipleSelection[0].handingSecretaryId,
        name: this.multipleSelection[0].handingSecretaryName
      }];
      this.batchSign.trialWay = this.wayList[0].id;
      this.batchSign.secretaryId = this.multipleSelection[0].handingSecretaryId;
      this.batchSign.secretaryName = this.multipleSelection[0].handingSecretaryName;
      this.batchSign.opinion = "通过";
      this.batchArbVisible = true;
    },
    batchReviewSubmit: function batchReviewSubmit(divisionLotForm) {
      var _this11 = this;
      this.$refs[divisionLotForm].validate(function (valid) {
        if (valid) {
          _this11.arbitratorList.forEach(function (item) {
            if (item.id == _this11.divisionLotForm.chiefArbitratorId) {
              _this11.divisionLotForm.chiefArbitratorName = item.name;
            }
          });
          _this11.divisionLotForm.caseIds = _this11.multipleSelectionId;
          (0, _inquiry.batchSendCompose)(_this11.divisionLotForm).then(function (res) {
            if (res.code == 1) {
              _this11.$message({
                message: "批量审核成功",
                type: "success"
              });
              _this11.divisionLotVisible = false;
              _this11.init();
              // 批量送达页面？？？
            } else {
              _this11.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      var _this12 = this;
      this.pageLimit = val;
      if ((0, _index2.hasValueInObj)(this.conditionData)) {
        // 有筛选条件的情况下
        this.conditionData.limit = val;
        this.conditionData.page = this.currentPage;
        (0, _inquiry.getList)(this.conditionData).then(function (res) {
          if (res.code == 1) {
            _this12.tableData = res.rows;
            _this12.total = res.total;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _inquiry.getList)({
          state: "23",
          limit: val,
          page: this.currentPage
        }).then(function (res) {
          if (res.code == 1) {
            _this12.tableData = res.rows;
            _this12.total = res.total;
          }
        });
      }
    },
    handleCurrentChange: function handleCurrentChange(val) {
      var _this13 = this;
      if ((0, _index2.hasValueInObj)(this.conditionData)) {
        // 有筛选条件的情况下
        this.conditionData.page = val;
        this.conditionData.limit = this.pageLimit;
        (0, _inquiry.getList)(this.conditionData).then(function (res) {
          if (res.code == 1) {
            _this13.tableData = res.rows;
            _this13.total = res.total;
            _this13.currentPage = val;
          }
        });
      } else {
        //没有筛选条件的情况下
        (0, _inquiry.getList)({
          state: "23",
          limit: this.pageLimit,
          page: val
        }).then(function (res) {
          if (res.code == 1) {
            _this13.tableData = res.rows;
            _this13.total = res.total;
            _this13.currentPage = val;
          }
        });
      }
    }
  }
};
exports.default = _default;